import { render } from "./SystemStatus.vue?vue&type=template&id=96d78982&scoped=true"
import script from "./SystemStatus.vue?vue&type=script&lang=js"
export * from "./SystemStatus.vue?vue&type=script&lang=js"

import "./SystemStatus.vue?vue&type=style&index=0&id=96d78982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d78982"]])

export default __exports__